// src/app/views/persona/dialog-form-persona/dialog-form-persona.component.ts
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, ChangeDetectorRef } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { ButtonAddComponent } from '@component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from '@component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from '@component/button-close-dialog/button-close-dialog.component';
import { ButtonDeleteComponent } from '@component/button-delete/button-delete.component';
import { ButtonSaveComponent } from '@component/button-save/button-save.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, TiposDocumentos } from '@models/base/identificadores.model';
import { EstadoCivilDto } from '@models/estadoCivil/estadoCivilDto.model';
import { CreatePersonaRequest } from '@models/persona/createPersonaRequest.model';
import { PersonaDetailDto } from '@models/persona/personaDetailDto.model';
import { UpdatePersonaRequest } from '@models/persona/updatePersonaRequest.model';
import { TipoDocumentoDto } from '@models/tipoDocumento/tipoDocumentoDto.model';
import { UsuarioDto } from '@models/usuario/usuarioDto.model';
import { EstadoCivilService } from '@services/estadoCivil/estadoCivil.service';
import { LoginService } from '@services/login/login.service';
import { PaisService } from '@services/pais/pais.service';
import { PersonaService } from '@services/persona/persona.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoDocumentoService } from '@services/tipoDocumento/tipoDocumento.service';
import { TipoPersonaService } from '@services/tipoPersona/tipoPersona.service';
import { BuscarPaisGeorefComponent } from '@views/busquedas/buscar-pais-georef/buscar-pais-georef.component';
import { BuscarProvinciaLocalidadGeorefComponent } from '@views/busquedas/buscar-provincia-localidad-georef/buscar-provincia-localidad-georef.component';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { isFalsy } from 'utility-types';

@Component({
  selector: 'app-dialog-form-persona',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    ButtonCloseDialogComponent,
    A11yModule,
    CommonModule,
    MatExpansionModule,
    ButtonSaveComponent,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    NgxSpinnerModule,
    MatTableModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSelectModule,
    FormsModule,
    MatSortModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatRippleModule,
    MatNativeDateModule,
    MatTabsModule,
    ButtonCancelDialogComponent,
    ButtonAddComponent,
    MatCheckboxModule,
    ButtonDeleteComponent,
    MatAutocompleteModule,
    MatChipsModule,
    BuscarPaisGeorefComponent,
    AppRolesDirective,
    BuscarProvinciaLocalidadGeorefComponent ,
    StatusBadgeComponent
  ],
  styleUrl: './dialog-form-persona.component.css',
  templateUrl: './dialog-form-persona.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogFormPersonaComponent {

  accionesDialog = AccionesDialog;
  form!: FormGroup;
  public personaDetailDto: PersonaDetailDto = new PersonaDetailDto();
  lstEstadosCivilModel: EstadoCivilDto[] = [];
  lstTipoDocumentoDto: TipoDocumentoDto[] = [];
  lstPaises: BaseDto[] = [];
  localidad!: BaseDto;
  idPersona: number = 0;
  formBuilder: FormBuilder = new FormBuilder();
  usuarioDto!: UsuarioDto;
  lstTiposPersona!: BaseDto[];

  get f() { return this.form.controls; }

  localidadSelec: number = 0;
  formLocalidad: FormControl = new FormControl("", Validators.compose([Validators.required]));
  filteredOptions?: Observable<any[]>;
  enviado!: boolean;

  constructor(
    public dialogRef: MatDialogRef<DialogFormPersonaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private personaService: PersonaService,
    private loginService: LoginService,
    private tipoDocumentoService: TipoDocumentoService,
    private paisService: PaisService,
    private router: Router,
    private snackBar: SnackBarService,
    private estadoCivilService: EstadoCivilService,
    private tipoPersonaService: TipoPersonaService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {
    this.personaDetailDto = this.data?.item || {};
    this.setForm();
  }

  ngOnInit(): void {
    this.usuarioDto = this.loginService.getCurrentUser();

    if (this.data?.item?.id) {
      this.getById(this.data?.item.id);
    }
    else{
      if(this.data?.idPersona)
        this.getById(this.data?.idPersona);
    }


    this.loadCatalogs();
  }

  setForm() {
    this.form = this.formBuilder.group({
      //Persona
      Nombre: [this.personaDetailDto.nombre || null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      Apellido: [this.personaDetailDto.apellido || null, Validators.compose([Validators.maxLength(150)])],
      NroDocumento: [this.personaDetailDto.nroDocumento || null, Validators.compose([Validators.maxLength(50)])],
      TelefonoPrincipal: [this.personaDetailDto.telefonoPrincipal || null, Validators.compose([Validators.required, Validators.maxLength(30)])],
      TelefonoAlternativo: [this.personaDetailDto.telefonoAlternativo || null, Validators.compose([Validators.maxLength(30)])],
      TelefonoLaboral: [this.personaDetailDto.telefonoLaboral || null, Validators.compose([Validators.maxLength(30)])],
      Sexo: [this.personaDetailDto.sexo || null],
      Correo: [this.personaDetailDto.correo || null, Validators.compose([Validators.required, Validators.email, Validators.maxLength(50)])],
      FechaNacimiento: [this.personaDetailDto.fechaNacimiento || null],
      Ubicacion: [this.personaDetailDto.ubicacion || null, Validators.compose([Validators.maxLength(200)])],
      UbicacionLaboral: [this.personaDetailDto.ubicacionLaboral || null, Validators.compose([Validators.maxLength(150)])],
      Pais: [this.personaDetailDto.pais?.id || null],
      CodigoPostal: [this.personaDetailDto.codigoCpa || null, Validators.compose([Validators.maxLength(8)])],
      EstadoCivil: [this.personaDetailDto.estadoCivil?.id || null],
      TiposDocumento: [this.personaDetailDto.tipoDocumento?.id || null],
      Ocupacion: [this.personaDetailDto.ocupacion || null, Validators.compose([Validators.maxLength(50)])],
      Observacion: [this.personaDetailDto.observacion || null, Validators.compose([Validators.maxLength(2000)])],
      Activo: [this.personaDetailDto.activo !== undefined ? this.personaDetailDto.activo : true],
      Localidad: [this.personaDetailDto.idLocalidad || null],
      TipoPersona: [this.personaDetailDto.tipoPersona?.id || null, Validators.compose([Validators.required])],
    });

    this.validaDocumentosSegunTipoDocumento();
  }

  loadCatalogs() {
    this.getAllTiposDocumentos();
    this.getAllEstadosCivil();
    this.getAllTiposPersona();
  }

  paisSeleccionado(country: any) {
    this.form.controls["Pais"].setValue(null);
    //this.form.controls["Pais"].setValue(country.name);
  }

  validaDocumentosSegunTipoDocumento() {
    this.form.controls["TiposDocumento"].valueChanges.subscribe(valor => {
      let tiposDocumentoControl = this.form.controls["TiposDocumento"];

      switch (valor) {
        case TiposDocumentos.DNI:
          tiposDocumentoControl.setValidators([Validators.pattern("^[0-9]*$")]);
          break;
        case TiposDocumentos.PASS:
          break;
      }

      tiposDocumentoControl.markAsDirty();
      tiposDocumentoControl.updateValueAndValidity();
    });
  }

  seleccionaLocalidad(data: any) {
    this.form.controls["Localidad"].setValue(data.id);
  }

  selectTipoDocumento(event: any) {
    if (event) {
      this.form.controls["NroDocumento"].enable();
      this.form.controls["NroDocumento"].setValue(null);
    } else {
      this.form.controls["NroDocumento"].disable();
    }
  }

  getAllTiposDocumentos() {
    this.spinner.show("spTiposDocumento");
    this.tipoDocumentoService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spTiposDocumento");
          this.lstTipoDocumentoDto = data;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.spinner.hide("spTiposDocumento");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  getAllEstadosCivil() {
    this.spinner.show("spEstadosCivil");
    this.estadoCivilService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spEstadosCivil");
          this.lstEstadosCivilModel = data;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.spinner.hide("spEstadosCivil");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  getAllTiposPersona() {
    this.spinner.show("spTiposPersona");
    this.tipoPersonaService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide("spTiposPersona");
          this.lstTiposPersona = data;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.spinner.hide("spTiposPersona");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  getById(id: number) {
    this.spinner.show("spPersonas");
    this.personaService.getPersonaById(id)
      .subscribe({
        next: (data) => {
          this.spinner.hide("spPersonas");
          this.personaDetailDto = data;
          this.setForm();
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.spinner.hide("spPersonas");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  agregar() {
    if (this.form.invalid) {
      this.markFormGroupTouched();
      return;
    }

    this.spinner.show("spPersona");
    this.personaService.create(this.setCreatePersonaRequest())
      .subscribe({
        next: (data) => {
          this.spinner.hide("spPersona");
          this.snackBar.showSuccess('Persona creada correctamente.', "Éxito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data });
        },
        error: (error) => {
          this.spinner.hide("spPersona");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  modificar() {
    if (this.form.invalid) {
      this.markFormGroupTouched();
      return;
    }

    this.spinner.show("spPersona");
    this.personaService.update(this.setUpdatePersonaRequest())
      .subscribe({
        next: (data) => {
          this.spinner.hide("spPersona");
          this.snackBar.showSuccess('Persona modificada correctamente.', "Éxito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data });
        },
        error: (error) => {
          this.spinner.hide("spPersona");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  eliminar() {
    if (!this.data?.item?.id) {
      this.snackBar.showError("No se puede eliminar: ID no válido", "Error");
      return;
    }

    this.spinner.show("spPersona");
    this.personaService.delete(this.data.item.id)
      .subscribe({
        next: () => {
          this.spinner.hide("spPersona");
          this.snackBar.showSuccess('Persona eliminada correctamente.', "Éxito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar });
        },
        error: (error) => {
          this.spinner.hide("spPersona");
          this.snackBar.showError(error, "Error");
          this.cdr.markForCheck();
        }
      });
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  setCreatePersonaRequest(): CreatePersonaRequest {
    const createPersonaRequest = new CreatePersonaRequest();

    createPersonaRequest.nombre = this.form.controls['Nombre'].value;
    createPersonaRequest.apellido = this.form.controls['Apellido'].value;
    createPersonaRequest.nroDocumento = this.form.controls['NroDocumento'].value;
    createPersonaRequest.idTipoDocumento = this.form.controls['TiposDocumento'].value ?? null;
    createPersonaRequest.idEstadoCivil = this.form.controls['EstadoCivil'].value ?? null;
    createPersonaRequest.telefonoPrincipal = this.form.controls['TelefonoPrincipal'].value;
    createPersonaRequest.telefonoAlternativo = this.form.controls['TelefonoAlternativo'].value;
    createPersonaRequest.telefonoLaboral = this.form.controls['TelefonoLaboral'].value;
    createPersonaRequest.sexo = this.form.controls['Sexo'].value ?? null;
    createPersonaRequest.correo = this.form.controls['Correo'].value;
    createPersonaRequest.fechaNacimiento = this.form.controls['FechaNacimiento'].value;
    createPersonaRequest.ubicacion = this.form.controls['Ubicacion'].value;
    createPersonaRequest.ubicacionLaboral = this.form.controls['UbicacionLaboral'].value;
    createPersonaRequest.idPais = this.form.controls['Pais'].value ?? null;
    createPersonaRequest.idLocalidad = this.form.controls['Localidad'].value ?? null;
    createPersonaRequest.codigoCpa = this.form.controls['CodigoPostal'].value;
    createPersonaRequest.observacion = this.form.controls['Observacion'].value;
    createPersonaRequest.ocupacion = this.form.controls['Ocupacion'].value;
    createPersonaRequest.activo = this.form.controls['Activo'].value;

    return createPersonaRequest;
  }

  setUpdatePersonaRequest(): UpdatePersonaRequest {
    const updatePersonaRequest = new UpdatePersonaRequest();

    updatePersonaRequest.id = this.data.item.id;
    updatePersonaRequest.nombre = this.form.controls['Nombre'].value;
    updatePersonaRequest.apellido = this.form.controls['Apellido'].value;
    updatePersonaRequest.nroDocumento = this.form.controls['NroDocumento'].value;
    updatePersonaRequest.idTipoDocumento = this.form.controls['TiposDocumento'].value ?? null;
    updatePersonaRequest.idEstadoCivil = this.form.controls['EstadoCivil'].value ?? null;
    updatePersonaRequest.telefonoPrincipal = this.form.controls['TelefonoPrincipal'].value;
    updatePersonaRequest.telefonoAlternativo = this.form.controls['TelefonoAlternativo'].value;
    updatePersonaRequest.telefonoLaboral = this.form.controls['TelefonoLaboral'].value;
    updatePersonaRequest.sexo = this.form.controls['Sexo'].value ?? null;
    updatePersonaRequest.correo = this.form.controls['Correo'].value;
    updatePersonaRequest.fechaNacimiento = this.form.controls['FechaNacimiento'].value ?? null;
    updatePersonaRequest.ubicacion = this.form.controls['Ubicacion'].value;
    updatePersonaRequest.ubicacionLaboral = this.form.controls['UbicacionLaboral'].value;
    updatePersonaRequest.idLocalidad = this.form.controls['Localidad'].value ?? null;
    updatePersonaRequest.codigoCpa = this.form.controls['CodigoPostal'].value;
    updatePersonaRequest.observacion = this.form.controls['Observacion'].value;
    updatePersonaRequest.ocupacion = this.form.controls['Ocupacion'].value;
    updatePersonaRequest.idPais = this.form.controls['Pais'].value ?? null;
    updatePersonaRequest.activo = this.form.controls['Activo'].value ?? null;

    return updatePersonaRequest;
  }

  private markFormGroupTouched() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
    });
    this.cdr.markForCheck();
  }

  //Validaciones
  validaLargoNumerico(control: FormControl) {
    if (control.value != null && control.value != "") {
      if (<number>control.value > 999999999999) {
        return { validaLargoNumerico: true };
      } else {
        return { validaLargoNumerico: false };
      }
    } else {
      return { validaLargoNumerico: false };
    }
  }

  validaPersonaByNroDocYTipoDoc(controlNroDoc: FormControl) {
    let idTipoDocumento = this.form.controls['TiposDocumento'].value;
    if (controlNroDoc.value.toString().length > 7 && !isFalsy(idTipoDocumento)) {
      let promesa = new Promise((resolve, reject) => {
        this.personaService.validaPersonaByNroDocYTipoDoc(this.personaDetailDto.id, controlNroDoc.value, idTipoDocumento)
          .subscribe(data => {
            if (data == true) {
              resolve({ existePersona: true });
            } else {
              resolve(true);
            }
          });
      });
      return promesa;
    } else {
      let promesa = new Promise((resolve, reject) => {
        resolve(true);
      });
      return promesa;
    }
  }

  isFalsy(valor: any) {
    return isFalsy(valor);
  }

  trackByItems(index: number, item: any): any {
    return item?.id || index;
  }
}
